function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 1C3.896 1 1 3.985 1 7.703 1 11.42 7.5 20.5 7.5 20.5S14 11.42 14 7.703C14 3.985 11.104 1 7.5 1zm0 9.75c-1.654 0-2.955-1.34-2.955-3.048 0-1.706 1.3-3.047 2.955-3.047 1.654 0 2.955 1.34 2.955 3.047S9.155 10.75 7.5 10.75z",
  stroke: "#717375",
  fill: "none"
});

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 21"
  }, props), _ref);
}

export default SvgLocation;